/**
 * @author: Ujjwal Jain
 * @file: additionalParams.js
 *
 * @copyright: KNOLSKAPE Solutions Pvt Ltd
 **/

import Immutable from 'immutable';
import actionConsts from 'constants/actions';
import { mergeListsBasedOnKey } from 'util/objectUtils';

const initialState = Immutable.fromJS({
    isFeedbackEnabled: false,
    isLeaderBoardEnabled: true,
    isReportEnabled: true
});


const additionalParams = (state = initialState, action = {}) => {
    switch (action.type) {
        case actionConsts.get('INIT_ADDITIONAL_PARAMS'):
            // Hard-disable feedback: always return false regardless of external payload
            // External feedback mechanism will be used instead
            return state
                .set('isFeedbackEnabled', false)
                .set('isLeaderBoardEnabled', action.payload.isLeaderBoardEnabled !== false)
                .set('isReportEnabled', action.payload.isReportEnabled !== false);
        default:
            return state;
    }
};

export default additionalParams;